import { DialogWrapper } from '../../../shared/components/common/dialogWrapper';
import CheckIcon from '@mui/icons-material/Check';
import ButtonWrapper from '../../../shared/formUtilities/useButton';
import { Box } from '@mui/material';
import TextWrapper from '../../../shared/formUtilities/useTextWrapper';
import { AppRoutes } from '../../../constants/appRoutes';
import { buildRegionizeRoute } from '../../../helpers/regionRouteHelper';

export const UserLockOutDialog = ({ state, onClose = (e) => {} }) => {
	return (
		<>
			<DialogWrapper
				titleClass="!w-full !items-center"
				maxWidth="xs"
				state={state}
				onClose={() => {
					onClose(false);
				}}
				title={`Temporarily locked`}
				content={
					<Box className="!text-sm text-center">
						<TextWrapper
							type="span"
							classList="caption"
							text="Too many wrong login attempts. Your account is now locked please "></TextWrapper>
						<a
							onClick={() => {
								onClose();
							}}
							className="!text-sm"
							href={`${buildRegionizeRoute(AppRoutes.ForgotPassword)}`}>
							reset your password
						</a>
						<TextWrapper
							type="span"
							classList="caption"
							text=" or wait a few minutes and try agian with correct password."></TextWrapper>
					</Box>
				}
				actions={
					<Box className="flex items-center">
						<ButtonWrapper
							icon={<CheckIcon></CheckIcon>}
							type="button"
							onClick={() => {
								onClose();
							}}
							label="Got it"></ButtonWrapper>
					</Box>
				}></DialogWrapper>
		</>
	);
};
